import { fetchClassStudents } from '@/api/resources/student.api';
import { useDisplayName } from '@/composables/useDisplayName';
import { useQueryWithToast } from '@/composables/useQueryWithToast';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { studentKeys } from './student.keys';

/** Pass a reactive class ID; null disables the query. */
export function useClassStudents(schoolClassId: MaybeRefOrGetter<number | null | undefined>) {
  const { nameSortation } = useDisplayName();
  const query = useQueryWithToast({
    queryKey: computed(() => studentKeys.classList(toValue(schoolClassId), nameSortation.value)),
    enabled: computed(() => toValue(schoolClassId) != null),
    queryFn: () => {
      const id = toValue(schoolClassId);
      return id == null ? [] : fetchClassStudents(id);
    },
  });

  return {
    allStudents: computed(() => query.data.value ?? []),
    isLoading: computed(() => query.isLoading.value || query.isFetching.value),
    studentsLoaded: computed(() => !query.isLoading.value && query.data.value != null),
  };
}
